import { CircularProgress, makeStyles } from '@material-ui/core';
import React from 'react';

const LoadingComponent = ()=>{
    const useStyles = makeStyles({
        loading:{
            minHeight:'400px',
            display:'flex',
            justifyContent:'center',
            alignItems:'center',
            flexDirection:'column',
            width:'100%'
        }
    });
    const classes = useStyles();
    return <div className={classes.loading}>
        <CircularProgress />
    </div>
};
export default LoadingComponent;